module.exports = __webpack_public_path__ + "img/close-circle.fbf7191d.svg";